module.exports = __webpack_public_path__ + "img/ch-1.d115acd0.gif";